/**
 * Axios configuration and interceptors
 */
import axios, { type AxiosResponse, type AxiosError } from 'axios'
import { useAuthStore } from '@/stores'

/**
 * Setup axios with default configuration and interceptors
 */
export function setupAxios(): void {
  // Set up global axios defaults
  axios.defaults.baseURL = '/'

  // Add global response error handling
  axios.interceptors.response.use(
    (response: AxiosResponse) => response,
    async (error: AxiosError) => {
      // If we get a 401, try to refresh token or redirect to login
      if (error.response?.status === 401 && 
          !error.config?.url?.includes('/oauth2/')) {
        
        const authStore = useAuthStore()
        
        if (authStore.isAuthenticated) {
          const refreshed = await authStore.performTokenRefresh()
          if (refreshed) {
            const originalRequest = error.config
            if (originalRequest && originalRequest.headers) {
              originalRequest.headers.Authorization = `Bearer ${authStore.getAccessToken}`
              return axios(originalRequest)
            }
          }
        }
      }
      return Promise.reject(error)
    }
  )
}

export default axios
